import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  gloassaryWords: [],
  countryList:[],
};

export const sharedReduxSlice = createSlice({
  name: "sharedReduxSlice",
  initialState: initialState,
  reducers: {
    setGloassaryWords: (state, actions) => {
      state.gloassaryWords = actions.payload;
    },
    setCountryList: (state, actions) => {
      state.countryList = actions.payload;
    },
  },
});
